import React, { useState, useMemo } from "react";
import { Search, Filter, MapPin, Star, Calendar, Phone, Clock, Users, Award } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

import Drsaurabhsir from "../assets/doctors/saurabhsir.jpeg";
import Dramitsir from "../assets/doctors/amitsir.jpeg";
import Drmaleicon from "../assets/doctors/drmaleicon.png";
import Drkavita from "../assets/doctors/kavita.jpeg";
import Drshivam from "../assets/doctors/shivam.jpeg";

// New imports based on your new doctors
import DrAlokRai from "../assets/doctors/DrAlokRai.jpg";
import DrChanchalKumar from "../assets/doctors/DrChanchalKumar.jpg";
import DrSKBhariya from "../assets/doctors/DrSKBhariya.jpg";
import DrSanjayYadav from "../assets/doctors/DrSanjayYadav.jpg";
import DrShashi from "../assets/doctors/DrShashi.jpg";
import DrShubhamSrivastava from "../assets/doctors/DrShubhamSrivastava.jpg";
import DrSudipta from "../assets/doctors/DrSudipta.jpg";
import DrUmeshKumar from "../assets/doctors/DrUmeshKumar.jpg";
import DrVaibhav from "../assets/doctors/DrVaibhav.jpg";
import DrVivekKatiyar from "../assets/doctors/DrVivekKatiyar.jpg";
import ProfNKAgarwal from "../assets/doctors/ProfNKAgarwal.jpg";
import ProfRajeshMeena from "../assets/doctors/ProfRajeshMeena.jpg";
import DrBirju from "../assets/doctors/DrBirju.jpg";
import DrAbhijeet from "../assets/doctors/DrAbhijeetKunwar.jpg";


// Specialties and hospitals lists
const specialties = [
  "Orthopedics",
  "Plastic Surgery",
  "Trauma Surgery",
];

// Doctor data with complete information for all doctors
export const doctorsData = [
  // 🟦 ORTHOPEDICS
  {
    id: 1,
    name: "Prof. Saurabh Singh",
    designation: "MS, MCH (Orthopedics)",
    description: "Professor In-charge, Trauma Centre, IMS, BHU & Professor Department of Orthopedics",
    imageUrl: Drsaurabhsir,
    rating: 4.9,
    experience: "15+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Today, 4:00 PM",
  },
  {
    id: 2,
    name: "Prof. Amit Rastogi",
    designation: "MS (Orthopedics)",
    description: "Renowned orthopedic surgeon specializing in joint replacements and sports injuries.",
    imageUrl: Dramitsir,
    rating: 4.8,
    experience: "12+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Tomorrow, 10:00 AM",
  },
  {
    id: 3,
    name: "Prof. Shivam Sinha",
    designation: "MS (Orthopedics)",
    description: "Expert in trauma surgery and orthopedic rehabilitation techniques.",
    imageUrl: Drshivam,
    rating: 4.7,
    experience: "10+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Today, 6:00 PM",
  },
  {
    id: 4,
    name: "Dr. Alok Rai",
    designation: "MS (Orthopedics)",
    description: "Orthopedic surgeon with focus on fracture management and bone disorders.",
    imageUrl: DrAlokRai,
    rating: 4.6,
    experience: "8+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Tomorrow, 11:00 AM",
  },
  {
    id: 5,
    name: "Dr. Chanchal Kumar Singh",
    designation: "MS (Orthopedics)",
    description: "Specializes in pediatric orthopedics and congenital deformities.",
    imageUrl: DrChanchalKumar,
    rating: 4.5,
    experience: "6+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Today, 1:00 PM",
  },
  {
    id: 6,
    name: "Dr. Sanjay Yadav",
    designation: "MS (Orthopedics)",
    description: "Specialist in orthopedic trauma and complex bone surgeries.",
    imageUrl: DrSanjayYadav,
    rating: 4.8,
    experience: "12+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Tomorrow, 9:00 AM",
  },
  {
    id: 7,
    name: "Dr. Subham Srivastava",
    designation: "MS (Orthopedics)",
    description: "Focused on joint disorders, arthritis, and orthopedic pain management.",
    imageUrl: DrShubhamSrivastava,
    rating: 4.6,
    experience: "7+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Tomorrow, 1:30 PM",
  },
  {
    id: 8,
    name: "Dr. Abhijeet Kunwar",
    designation: "MS(Orthopedics)",
    description: "Focused on joint disorders, arthritis, and orthopedic pain management.",
    imageUrl: DrAbhijeet,
    rating: 4.6,
    experience: "7+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Tomorrow, 1:30 PM",
  },
  {
    id: 9,
    name: "Dr. Birju Majhi",
    designation: "MS(Orthopedics)",
    description: "Focused on joint disorders, arthritis, and orthopedic pain management.",
    imageUrl: DrBirju,
    rating: 4.6,
    experience: "7+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Orthopedics",
    nextAvailable: "Tomorrow, 1:30 PM",
  },

  // 🟩 PLASTIC SURGERY
  {
    id: 10,
    name: "Dr. Shashi Prakash Mishra",
    designation: "MS (Plastic Surgery)",
    description: "Plastic and reconstructive surgeon with expertise in burns and cosmetic surgery.",
    imageUrl: DrShashi,
    rating: 4.7,
    experience: "14+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Plastic Surgery",
    nextAvailable: "Today, 4:30 PM",
  },
  {
    id: 11,
    name: "Dr. Sudipta Bera",
    designation: "MS (Plastic Surgery)",
    description: "Plastic surgeon with focus on craniofacial surgery and aesthetic procedures.",
    imageUrl: DrSudipta,
    rating: 4.8,
    experience: "9+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Plastic Surgery",
    nextAvailable: "Today, 2:00 PM",
  },
  {
    id: 12,
    name: "Dr. Umesh Kumar",
    designation: "MS (Plastic Surgery)",
    description: "Expert in reconstructive microsurgery and cosmetic treatments.",
    imageUrl: DrUmeshKumar,
    rating: 4.9,
    experience: "16+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Plastic Surgery",
    nextAvailable: "Tomorrow, 5:00 PM",
  },
  {
    id: 13,
    name: "Dr. Vaibhav Jain",
    designation: "MS (Plastic Surgery)",
    description: "Plastic surgeon with specialization in hand surgery and maxillofacial trauma.",
    imageUrl: DrVaibhav,
    rating: 4.7,
    experience: "12+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Plastic Surgery",
    nextAvailable: "Today, 11:00 AM",
  },
  {
    id: 14,
    name: "Prof. N.K.Agarwal",
    designation: "MS (Plastic Surgery)",
    description: "Senior plastic surgeon experienced in complex reconstructions and burns.",
    imageUrl: ProfNKAgarwal,
    rating: 4.8,
    experience: "10+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Plastic Surgery",
    nextAvailable: "Tomorrow, 9:30 AM",
  },

  // ⚠️ OTHERS
  {
    id: 15,
    name: "Prof. Rajesh Meena",
    designation: "MD Anesthesia, PDCC",
    description: "Senior anesthesiologist with expertise in cardiac anesthesia and pain management.",
    imageUrl: ProfRajeshMeena,
    rating: 4.9,
    experience: "18+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Cardiology",
    nextAvailable: "Tomorrow, 2:00 PM",
  },
  {
    id: 16,
    name: "Dr. Kavita Meena",
    designation: "MD Anesthesia, PDCC",
    description: "Neuro-anesthesiologist specialized in critical care and neuro-intervention support.",
    imageUrl: Drkavita,
    rating: 4.8,
    experience: "14+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Neurology",
    nextAvailable: "Today, 5:30 PM",
  },
  {
    id: 17,
    name: "Dr. S.K.Bhartiya",
    designation: "MS (General Surgery)",
    description: "General surgeon skilled in laparoscopic and gastrointestinal surgeries.",
    imageUrl: DrSKBhariya,
    rating: 4.7,
    experience: "10+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Trauma Surgery",
    nextAvailable: "Today, 3:00 PM",
  },
  {
    id: 18,
    name: "Dr. Vivek Katiyar",
    designation: "MS (General Surgery)",
    description: "ENT and head-neck specialist with expertise in sinus and vocal cord surgeries.",
    imageUrl: DrVivekKatiyar,
    rating: 4.5,
    experience: "8+ years",
    hospital: "Trauma Centre, IMS BHU",
    specialty: "Trauma Surgery",
    nextAvailable: "Tomorrow, 10:00 AM",
  },
];



const Doctor = () => {
  const [activeTab, setActiveTab] = useState("doctor");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedHospital, setSelectedHospital] = useState("All");
  const [selectedSpecialty, setSelectedSpecialty] = useState("All");
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [sortBy, setSortBy] = useState("relevance");
  const navigate = useNavigate();
  const [specialty, setsSpecialty] = useState("");

  // Memoized filtered doctors to prevent unnecessary re-calculations
  const filteredDoctors = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();

    let filtered = doctorsData.filter((doctor) => {
      // Search query matching
      const matchesQuery = !query ||
        doctor.name.toLowerCase().includes(query) ||
        (doctor.designation && doctor.designation.toLowerCase().includes(query)) ||
        (doctor.description && doctor.description.toLowerCase().includes(query)) ||
        (doctor.specialty && doctor.specialty.toLowerCase().includes(query));

      // Filter by hospital
      const matchesHospital = selectedHospital === "All" ||
        doctor.hospital === selectedHospital;

      // Filter by specialty
      const matchesSpecialty = selectedSpecialty === "All" ||
        doctor.specialty === selectedSpecialty;

      return matchesQuery && matchesHospital && matchesSpecialty;
    });

    // Apply sorting
    if (sortBy === "rating") {
      filtered.sort((a, b) => (b.rating || 0) - (a.rating || 0));
    } else if (sortBy === "experience") {
      filtered.sort((a, b) => {
        const aExp = a.experience ? parseInt(a.experience) : 0;
        const bExp = b.experience ? parseInt(b.experience) : 0;
        return bExp - aExp;
      });
    }

    return filtered;
  }, [searchQuery, selectedHospital, selectedSpecialty, sortBy]);

  // Function to safely navigate to doctor profile
  const handleViewProfile = (doctorId) => {
    if (typeof doctorId === 'number' && doctorId > 0) {
      navigate(`/doctor-profile/${doctorId}`);
    }
  };

  // Function to safely navigate to appointment booking
  const handleBookAppointment = (doctorId) => {
    if (typeof doctorId === 'number' && doctorId > 0) {
      navigate(`/book-appointment/${doctorId}`);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Section with Gradient Overlay */}
      <div className="relative min-h-[50vh] sm:min-h-[60vh] md:min-h-[70vh] bg-cover bg-center bg-no-repeat shadow-md" style={{ backgroundImage: `url('/assets/Doctor-Frame.png')` }}>
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/70 to-teal-900/70" />

        <div className="relative z-10 flex flex-col items-center justify-center mt-10 h-full px-4 sm:px-6 lg:px-8 text-white">
          <h1 className="mb-3 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-center drop-shadow-md">
            🩺 Find Your Specialist
          </h1>
          <p className="mb-6 sm:mb-8 text-center text-white/80 text-sm sm:text-base md:text-lg max-w-xl">
            Browse our trusted network of expert doctors and medical professionals
          </p>

          {/* Modern Glassy Search Box */}
          <div className="w-full max-w-4xl sm:max-w-5xl p-4 sm:p-6 md:p-8 mx-auto rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl transition-all duration-300 ease-in-out">

            {/* Tab Toggle */}
            <div className="flex justify-center mb-6 sm:mb-8 p-1 sm:p-2 bg-white rounded-2xl shadow-xl w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg mx-auto">
              {["doctor", "department"].map((tab) => (
                <button
                  key={tab}
                  className={`flex-1 px-4 sm:px-6 py-2 sm:py-3 text-xs sm:text-sm md:text-base font-semibold rounded-xl transition-all duration-300 ${activeTab === tab
                      ? "bg-gradient-to-r from-blue-600 to-teal-400 text-white shadow-lg scale-[1.02]"
                      : "bg-white text-gray-700 hover:bg-gray-100"
                    }`}
                  onClick={() => setActiveTab(tab)}
                  aria-pressed={activeTab === tab}
                >
                  {tab === "doctor" ? "Doctor" : "Department"}
                </button>
              ))}
            </div>

            {/* Search Inputs */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-6">
              {activeTab === "doctor" ? (
                <>
                  <div className="relative flex-grow">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Search by doctor name or specialty"
                      className="w-full pl-10 sm:pl-12 pr-4 sm:pr-5 py-2.5 sm:py-3.5 text-sm sm:text-base md:text-lg text-gray-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white shadow-sm border border-gray-200 hover:border-blue-300 transition-colors"
                      aria-label="Search doctors"
                    />
                    <Search
                      className="absolute w-5 sm:w-6 h-5 sm:h-6 text-gray-400 left-3 sm:left-3.5 top-1/2 -translate-y-1/2"
                      aria-hidden="true"
                    />
                  </div>
                  <button
                    onClick={() => setIsFiltersOpen(!isFiltersOpen)}
                    className="flex items-center justify-center gap-2 px-4 sm:px-5 py-2 sm:py-3 text-sm sm:text-base font-semibold text-white rounded-lg bg-gradient-to-r from-teal-500 to-blue-500 hover:scale-105 transition min-w-[100px]"
                    aria-expanded={isFiltersOpen}
                    aria-controls="filters"
                  >
                    <Filter className="w-4 sm:w-5 h-4 sm:h-5" />
                    Filters
                  </button>
                </>
              ) : (
                <div className="relative flex-grow">
                  <select
                    value={selectedSpecialty}
                    onChange={(e) => setSelectedSpecialty(e.target.value)}
                    className="w-full pl-10 sm:pl-12 pr-4 sm:pr-5 py-2.5 sm:py-3.5 text-sm sm:text-base md:text-lg text-gray-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white shadow-sm border border-gray-200 hover:border-blue-300 transition-colors"
                      aria-label="Search specialty"
                  >
                    <option value="All">All Department</option>
                    {specialties.map((specialty) => (
                      <option key={specialty} value={specialty}>
                        {specialty}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Results Section */}
      <div className="container px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-10 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 sm:mb-6">
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800">
            {filteredDoctors.length} {filteredDoctors.length === 1 ? 'Doctor' : 'Doctors'} Found
          </h2>
        </div>

        {/* Doctor Cards */}
        {filteredDoctors.length > 0 ? (
          <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
            {filteredDoctors.map((doctor) => (
              <div
                key={doctor.id}
                className="overflow-hidden transition-all bg-white border border-gray-100 rounded-xl hover:shadow-lg hover:border-blue-100"
              >
                {/* Doctor Card Header with Image */}
                <div className="relative flex items-center p-4 sm:p-5 border-b border-gray-100">
                  <div className="flex-shrink-0 mr-3 sm:mr-4">
                    <div className="relative w-16 sm:w-20 md:w-24 h-16 sm:h-20 md:h-24 rounded-lg overflow-hidden shadow-sm aspect-square">
                      <img
                        src={doctor.imageUrl}
                        alt={doctor.name}
                        className="object-cover w-full h-full"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = Drmaleicon; // Fallback image
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex-1 min-w-0">
                    <h3 className="text-base sm:text-lg md:text-xl font-semibold text-blue-900">{doctor.name}</h3>
                    <p className="text-sm sm:text-base font-medium text-blue-800/80">{doctor.designation || "Specialist"}</p>

                    {(doctor.rating || doctor.patientsServed) && (
                      <div className="flex items-center mt-1 text-sm sm:text-base">
                        {/* {doctor.rating && (
                          <>
                            <Star className="w-3 sm:w-4 h-3 sm:h-4 mr-1 text-yellow-500 fill-yellow-500" />
                            <span className="font-medium">{doctor.rating}</span>
                          </>
                        )} */}
                        {/* {doctor.rating && doctor.patientsServed && (
                          <span className="mx-2 text-gray-400">•</span>
                        )}
                        {doctor.patientsServed && (
                          <span>{doctor.patientsServed}+ patients</span>
                        )} */}
                      </div>
                    )}

                    {doctor.hospital && (
                      <div className="flex items-center mt-1 text-sm sm:text-base text-gray-600">
                        <MapPin className="w-3 sm:w-4 h-3 sm:h-4 mr-1 flex-shrink-0" />
                        <span className="truncate">{doctor.hospital}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Doctor Info Section */}
                <div className="p-4 sm:p-5">
                  {doctor.description && (
                    <p className="text-sm sm:text-base text-gray-600 line-clamp-2">{doctor.description}</p>
                  )}

                  {/* Doctor Stats Grid */}
                  <div className="grid grid-cols-3 gap-2 sm:gap-3 mt-3 sm:mt-4">
                    {/* {doctor.experience && (
                      <div className="p-2 sm:p-3 text-center bg-blue-50 rounded">
                        <Award className="w-4 sm:w-5 h-4 sm:h-5 mx-auto mb-1 text-blue-600" />
                        <div className="text-xs sm:text-sm font-semibold text-blue-800">{doctor.experience}</div>
                        <div className="text-xs sm:text-sm text-blue-600">Experience</div>
                      </div>
                    )} */}

                    {/* {doctor.nextAvailable && (
                      <div className="p-2 sm:p-3 text-center bg-green-50 rounded">
                        <Clock className="w-4 sm:w-5 h-4 sm:h-5 mx-auto mb-1 text-green-600" />
                        <div className="text-xs sm:text-sm font-semibold text-green-800">
                          {doctor.nextAvailable.includes("Today") ? "Today" :
                            doctor.nextAvailable.includes("Tomorrow") ? "Tomorrow" :
                              doctor.nextAvailable.split(",")[0]}
                        </div>
                        <div className="text-xs sm:text-sm text-green-600">Available</div>
                      </div>
                    )} */}

                    {/* {doctor.patientsServed && (
                      <div className="p-2 sm:p-3 text-center bg-purple-50 rounded">
                        <Users className="w-4 sm:w-5 h-4 sm:h-5 mx-auto mb-1 text-purple-600" />
                        <div className="text-xs sm:text-sm font-semibold text-purple-800">{doctor.patientsServed}+</div>
                        <div className="text-xs sm:text-sm text-purple-600">Patients</div>
                      </div>
                    )} */}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex border-t border-gray-100">
                  <button
                    className="flex items-center justify-center flex-1 gap-1 px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base font-medium text-blue-700 transition-colors border-r border-gray-100 hover:bg-blue-50"
                    onClick={() => handleViewProfile(doctor.id)}
                    aria-label={`View profile of Dr. ${doctor.name}`}
                  >
                    {/* <Phone className="w-3 sm:w-4 h-3 sm:h-4" /> */}
                    View Profile
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 sm:py-16">
            <div className="p-3 sm:p-4 mb-3 sm:mb-4 text-blue-800 bg-blue-100 rounded-full">
              <Search className="w-6 sm:w-8 h-6 sm:h-8" />
            </div>
            <h3 className="mb-1 sm:mb-2 text-lg sm:text-xl md:text-2xl font-semibold text-gray-800">No doctors found</h3>
            <p className="text-sm sm:text-base md:text-lg text-gray-600">Try adjusting your search or filters</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Doctor;